import { Typography as MuiTypography, TypographyProps as MuiTypographyProps } from '@mui/material'
import React from 'react'
import { colors } from '../themes/colors'

interface TypographyProps extends MuiTypographyProps {
  color?: keyof typeof colors
}
type Props = TypographyProps & { component?: React.ElementType }

// Currently not used. Looking to replace use of current typography with this.
const Typography: React.FC<Props> = ({ color, ...props }) => {
  return <MuiTypography color={color ? colors[color] : undefined} {...props}></MuiTypography>
}

export default Typography
